import QuestionValue from "./QuestionValue";
import QuestionValueFraction from "./QuestionValueFraction";

export default class QuestionValueRatio extends QuestionValueFraction {
    constructor(numerator, denominator) {
        super(numerator, denominator);
    }

    toString() {
        return this._numerator + ":" + this._denominator;
    }
}